// URL API
let urlApi = '';
let urlApi2 = '';
let urlApi3 = '';
let urlApi4 = '';
let urlApi5Teste = '';
let urlApiV2 = '';

// CONSTANT FROM DEV
let isDebug = false;

// CHECK HOST
if (location.hostname === "localhost"  || location.hostname.includes('test-vue-dev') || location.hostname === "127.0.0.1" || location.hostname === "marqponto-web-dev.azurewebsites.net") {
  console.log("Local");
  urlApi = "https://marqponto-api-dev.azurewebsites.net/";
  urlApi2 = "https://marqponto-core-dev.azurewebsites.net/api/";
  urlApi3 = "https://marqponto-report-dev.azurewebsites.net/api/";
  urlApi4 = "https://marq-point-api-dev.azurewebsites.net/";
  urlApiV2 = "https://marqhr-api-dev.azurewebsites.net/"
  urlApi5Teste = "https://marq-point-api-dev.azurewebsites.net/";

  isDebug = true;
} else if (location.hostname.includes("marqponto-web-test.azurewebsites")) {
  console.log("Local stag");
  urlApi = "https://marqponto-api-stag.azurewebsites.net/";
  urlApi2 = "https://marqponto-core-stag.azurewebsites.net/api/";
  urlApi3 = "https://marqponto-report-stag.azurewebsites.net/api/";
  urlApi4 = "https://marq-point-api-dev.azurewebsites.net/";
  urlApi5Teste = "https://marq-point-api-dev.azurewebsites.net/";

  isDebug = true;
} else if (location.hostname.includes('stag')) {
  urlApi = "https://marqhr-apilegacy-stag.azurewebsites.net/";
  urlApi2 = "https://marqhr-core-stag.azurewebsites.net/";
  urlApi3 = "https://marqhr-report-stag.azurewebsites.net/";
  urlApiV2 = "https://marqhr-api-stag.azurewebsites.net/";
  urlApi5Teste = "https://marqhr-points-stag.azurewebsites.net/";
  urlApi4 = "https://marqhr-points-stag.azurewebsites.net/";
  isDebug = true;

}
else {
  urlApi = "https://marqponto-api.azurewebsites.net/";
  urlApi2 = "https://marqponto-core.azurewebsites.net/api/";
  urlApi3 = "https://marqponto-report.azurewebsites.net/api/";
  urlApi4 = "https://api.marqhr.com/points/";
  urlApiV2 = "https://api.marqhr.com.br/"
  urlApi5Teste = "https://api.marqhr.com/points/";

  isDebug = false;
}

//CLARITY
(function(c,l,a,r,i,t,y){
  c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
  t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;
  y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);
})(window, document, "clarity", "script", "jflsmvqwwh");

//RUN ALL THE TIME
export const GET_ALL_TASKS = urlApi + 'api/v1/user/tasks/web';

// VERSION
export const VERSION = "1.0.0.0";

// New
export const NEW_REGISTER_POINT = urlApi4 + 'userPoint/registerpoint';

// URL CONSTANT
// CORE
export const REGISTER_POINT_CORE = urlApi2 + 'core/web/register';
export const ADMIN_REGISTER_POINT = urlApi2 + 'core/web/modepoint/register';

// POINT
export const POINT_HISTORY = urlApi + 'api/v4/point/client/points';

// REPORT
export const ABSENCE_EMPLOYEE = urlApi3 + '/report/absence-employee';
export const ABSENCE_EMPLOYEE_ADMIN = urlApi3 + '/report/absence-manager';
export const REPORT_SOLICITATIONS = urlApi3 + 'report/solicitations';
export const WHO_IN_LATE = urlApi3 + 'report/back/dash/WhoIsLateNow';
export const WHO_WORKING = urlApi3 + 'report/back/dash/WhoWorkingNow';
export const WHO_IN_INTERVAL = urlApi3 + 'report/back/dash/WhoIsIntervalNow';
export const WHO_IN_FAULT = urlApi3 + 'report/back/dash/WhoIsMissingNow';
export const WHO_IN_DAY_OFF = urlApi3 + 'report/back/dash/WhoInDayOff';
export const WHO_IN_PAUSE = urlApi3 + 'report/back/dash/WhoInPause';
export const WHO_ABSENCE = urlApi3 + 'report/back/dash/absence';


// DEFAULT
export const IS_DEBUG = isDebug;
export const CHECK_PAUSE = urlApi + 'api/v1/point/client/pause';
export const ERROR_500 = urlApi + 'api/v1/info/Error500';
export const ME_SOLICITATION = urlApi + 'api/v2/solicitation/GetMeSolicitations';
export const LOGIN = urlApi + 'api/security/token';
export const FORGOT_PASS = urlApi + 'api/v1/user/forgotPassword';
export const SEND_LOG_REPORT = urlApi + 'api/v1/info/web/pointLogReport';
export const USER_ME = urlApi + 'api/v1/user/me';
export const CREATE_ABSENCE_EMPLOYEE = urlApi + 'v1/absence/request';
export const DETAIL_ABSENCE = urlApi + 'v1/absence/';
export const ABSENCE_APPROVE_MANAGER = urlApi + 'v1/absence/approve/manager';
export const ABSENCE_CANCEL = urlApi + 'v1/absence/';
export const GET_LIST_HOLIDAY = urlApi + 'api/v1/info/getVacationTypeToSelectBox';
export const POINT_CLIENT_POINTS = urlApi + 'api/v2/user/home';
export const BALANCE_HOURS = urlApi + 'api/v2/balance/web/resume';
export const BALANCE_HOURS_FILTERED = urlApi  + 'api/v1/balance/web/resume/filter';
export const POINT_HISTORY_OC = urlApi + 'api/v2/point/web/occurrences?';
export const POINT_FILTER = urlApi + 'api/v2/point/client/points';
export const POINT_DETAIL = urlApi + 'api/v1/point/client/detail/';
export const REGISTER_POINT = urlApi + 'api/v1/registerpoint/web/register';
export const PAUSE_REGISTER_POINT = urlApi + 'api/v1/pause/web/register';
export const SEND_SUGGESTION = urlApi + 'api/v1/info/ImprovementSuggestion';
export const SEND_BUG = urlApi + 'api/v1/info/ProblemReport';
export const POINT_DAY_DETAIL = urlApi + 'api/v3/point/client/registerpoint/detail';
export const DATA_EMPLOYEE = urlApi + 'api/v1/profile/employee/me';
export const CHECK_USER_NPS = urlApi + 'api/v1/company/showUserNps';
export const SEND_USER_NPS = urlApi + 'api/v1/company/RegisterUserNps';
export const SEND_USER_FEELING = urlApi + 'api/v1/user/mood/register';
export const HOME_LAST_POINTS2 = urlApi + 'api/v2/user/homeLastPoints';
export const HOME_LAST_SOLICITATIONS = urlApi + 'api/v1/solicitation/web/home/solicitations';
export const HOME_CHECK_NOTIFICATIONS = urlApi + 'api/v1/user/HasNotification';
export const HOME_NOTIFICATIONS = urlApi + 'api/v1/user/GetMeNotifications';
export const HOME_RESUME2 = urlApi + 'api/v3/user/homeResume';
export const SHARE_INFO = urlApi + 'api/v1/point/share/email/';
export const HOUR_BALANCE = urlApi + 'api/v1/user/getHoursBalancePerPeriodo';
export const ACTUAL_PROGRESS = urlApi + 'api/v1/point/client/ActualProgress';
export const ACTUAL_PROGRESS_V2 = urlApi + 'api/v2/point/client/ActualProgress';
export const USER_ACCESS = urlApi + 'api/v1/client/web/access';
export const CHECK_TEAM = urlApi + 'api/v1/user/myTeam';
export const GET_ME_NOTICES = urlApi + 'api/v1/user/GetMeNotices';
export const GET_FEEDBACK = urlApi + 'api/v1/feedback/app/myfeedbacks';
export const GET_EMPLOYEE_FEEDBACK = urlApi + 'api/v1/feedback/app/usersToFeedback';
export const GET_COMPETENCE_FEEDBACK = urlApi + 'api/v1/feedback/app/companyCompetences';
export const GET_DETAIL_FEEDBACK = urlApi + 'api/v1/feedback/app/';
export const CREATE_FEEDBACK = urlApi + 'api/v1/feedback/new';
export const REQUEST_FEEDBACK = urlApi + 'api/v1/feedback/app/requestFeedback';
export const FEEDBACK_CHECK_PERMISSION = urlApi + 'api/v1/feedback/app/sendFeedbackPermissions';
export const GET_MAIN_HOME = urlApi + 'api/v2/user/home/current';
export const GET_ME_NOTICES_HOME = urlApi + 'api/v2/user/notices';
export const READ_USER_NOTICE = urlApi + 'api/v1/user/readUserNotice/';
export const USER_PIN = urlApi + 'api/v1/user/ByPin';
export const CHECK_MENU = urlApi + 'api/v2/user/web/GetPendingActionsToUser';
export const EXIT_MODE_POINT = urlApi + 'api/v1/user/web/exit';
export const NOTICE_PENDING = urlApi + 'api/v1/user/GetNoticePendingToRead';
export const POINT_DAY = urlApi + 'api/v1/point/client/pointday/';
export const WHO_MUCH_FAIL = urlApi + 'api/v1/info/SendLoginTry';
export const TIMER = urlApi + '/api/v1/user/time?i=';
export const PROFILE_HOURS = urlApi + 'api/v2/profile/';
export const UPLOAD_IMG = urlApi  + 'api/v1/info/uploadImage';
export const ADJUSTMENT = urlApi  + 'api/v1/solicitation/adjustmentPoint';
export const CAN_MAKE_SOLICITATION = urlApi  + 'api/v1/solicitation/canMakeSolicitation';
export const MY_TEAM_INFO = urlApi  + 'api/v2/user/myTeamInfo';
export const SEARCH_EMPLY = urlApi  + 'api/v2/user/searchEmployee';
export const DATA_EMPLOYER = urlApi  + 'api/v1/profile/employee';
export const DATA_EMPLOYER2 = urlApi  + 'api/v2/user/employee';
export const DATA_EMPLOYER_FAULTS = urlApi  + 'api/v2/user/employee/faults';
export const DATA_EMPLOYER_OC = urlApi  + 'api/v2/user/employee/occurrences';
export const DATA_EMPLOYER_BALANCE = urlApi  + 'api/v2/user/employee/balance';
export const PROFILE_POINT = urlApi  + 'api/v1/profile/profilePoints';
export const EMAIL_WELCOME = urlApi  + 'api/v1/info/sendEmailWelcomeToEmployee';
export const GET_COMPANY_ADJ = urlApi  + 'api/v2/company/GetCompanyAdjustmentCategory';
export const PAUSE_DETAIL = urlApi  + 'api/v1/pause/detail?u=';
export const PAUSE_MOTIVES = urlApi  + 'api/v1/pause/Motives?i=';
export const CHANGE_PASSWORD = urlApi  + 'api/v1/user/updatePassword';
export const ATT_USER = urlApi  + 'api/v1/user/web/detail';
export const ATT_USER_PHOTO = urlApi  + 'api/v1/user/updatePhoto';
export const ADD_COMMENT_COMMUNICATION = urlApi + 'api/v1/user/companyStatementInteraction/add';
export const ADD_REACTION_COMMUNICATION = urlApi + 'api/v1/user/companystatement/react/add';
export const DELETE_COMMENT_COMMUNICATION = urlApi +'api/v1/user/companyStatementInteraction/delete/';
export const REFUNDS_MANAGER = urlApi +'v1/refund/team';
export const REFUNDS_COLLABORATOR = urlApi +'v1/refund/employee';
export const EXPENSE_CATEGORY = urlApi +'v1/refund/client/categories';
export const DOCUMENT_UPLOAD = urlApi +'api/v1/info/refund/upload';
export const REQUEST_REFUNDS = urlApi +'v1/refund/request/web';
export const CHANGE_STATUS_REFUNDS = urlApi +'v1/refund/status';
export const REFUND_HISTORY = urlApi +'v1/refund/histories/';
export const REFUND_POLICY = urlApi +'v1/refund/policies/';


export const PAUSE_MODAL_INFO = urlApi  + 'api/v1/pause/ModalInfo?u=';
export const GET_USER_POINT_FILTER = urlApi  + 'api/v1/report/GetUserPointFilter';
export const PAUSES_FROM_DAY = urlApi  + 'api/v1/pause/pausesFromDay';
export const ADN_DENIED_MOTIVE = urlApi  + 'api/v1/solicitation/adjustmentDeniedMotive?id=';
export const DAY_DETAIL = urlApi  + 'api/v1/point/client/FullDetail/';
export const GET_SOLICITATION = urlApi  + 'api/v1/solicitation/getSolicitationById';
export const REQUEST_UPDATE_STATUS = urlApi  + 'api/v1/solicitation/updateStatus';
export const GET_USER_TEAM = urlApi  + 'api/v1/info/GetTeams?i=';
export const GET_LIST_SOLICITATION = urlApi  + 'api/v1/solicitation/getSolicitations';
export const ALL_TEAM = urlApi + 'api/v1/info/getTeams';
export const ALL_OFFICE = urlApi + 'api/v1/info/getOffices';
export const ALL_WORK_SHIFT = urlApi + 'api/v1/info/getWorkShifts';
export const GET_USER_MIRROR = urlApi + 'api/v1/mirror/GetUserMirrors';
export const MIRROR_PDF = urlApi + 'api/v1/mirror/pdf/';
export const MIRROR_WEB_PDF_CUSTOM = urlApi + 'api/v1/mirror/WebPdfCustomUserWeb/';
export const DOCUMENT_WEB_PDF_CUSTOM = urlApi + 'api/v2/user/userdocument/logSignature?id=';
export const MOTIVE_DISAPPROVED = urlApi + 'api/v1/solicitation/adjustmentDeniedMotive';
export const CANCEL_FEEDBACK = urlApi + 'api/v1/feedback/app/denyFeedbackRequest/';
export const CHECK_HAS_MSG_CHAT = urlApi + 'api/v1/chat/HasMessageUnread?i=';
export const SEND_MESSAGE = urlApi + 'api/v1/chat/SendMessage';
export const GET_LIS_CHAT = urlApi + 'api/v1/chat/conversations?i=';
export const GET_DATA_CHAT = urlApi + 'api/v1/chat/employee/chat?i=';
export const HAS_OPENED_CHAT = urlApi  + 'api/v1/chat/HasChatOpened';
export const SEARCH_USER_CHAT = urlApi  + 'api/v1/chat/conversationChat/admins';
export const CHECK_SEARCH_USER = urlApi  + 'api/v1/chat/chatAdmin?i=';

export const CHECK_NPS_USER = urlApi  + 'api/v1/company/CheckUserNps';
export const POSTPONE_NPS_USER = urlApi  + 'api/v1/company/PostponeUserNps';
export const REGISTER_NPS_USER = urlApi  + 'api/v1/company/RegisterUserNps';

export const GET_POINT_VOUCHER = urlApi  + 'api/v3/point/day-receipt/'
export const GET_POINT_VOUCHER_EMAIL = urlApi  + 'api/v3/point/day-receiptEmail/';

export const GET_SIGN_VOUCHER = urlApi + ''
export const GET_SIGN_VOUCHER_EMAIL = urlApi + ''

export const GET_DOCUMENT_FOLDERS = urlApi  + 'api/v2/company/client/getDocumentsFolderToUser';
export const GET_DOCUMENT_FOLDERLESS = urlApi + 'api/v2/company/client/documentsNoFolder'
export const GET_FOLDERS_DETAIL = urlApi  + 'api/v2/company/client/getDocumentsToUser/';
export const GET_SIGNATURE_DETAIL = urlApi  + 'api/v2/company/client/signature/details/';
export const PUT_ACCEPT_SIGNATURE = urlApi + 'v1/signature/sign/web';
export const POST_PASSWORD_ATTACHMENT = urlApi  + 'api/v2/company/client/getUserDocumentWithPassword';

export const GET_REQUEST_DOCUMENTS = urlApi  + 'v1/document/requested/employee';
export const SEND_REQUESTED_DOCUMENT = urlApi  + 'v1/document/send-requested';

export const JUSTIFY_HE = urlApi  + 'api/v1/user/justify';
export const WORKING_LOCAL_EMPLOYEE = urlApi  + 'api/v1/workingLocal/updateWorkingLocalEmployee';
export const WORKING_LOCAL_EMPLOYEE_TODAY = urlApi  + 'api/v1/workingLocal/Last/User';


export const GET_ALL_ANNOUCEMENTS = urlApi + 'api/v1/client/companyStatements/'
export const READ_USER_NOTICE_ATT = urlApi + 'api/v1/client/companyStatement/read/'

export const GET_ALL_STATUS = urlApi + 'api/v1/client/app/home/currentStatus';
export const GET_ADVICES = urlApi + 'api/v1/client/app/advice'

export const HOME_LAST_POINTS = urlApi + 'api/v1/client/app/homeLastPoints?device=web'

export const LEFT_MENU_FEATURES = `${urlApi}api/v1/client/app/features`
export const GET_MY_TEAM = `${urlApi}api/v1/user/myTeam`

export const GET_EXCEPTION = urlApi + 'v1/sporadic/category'
export const DOWNLOAD_VAUCHER = urlApi + 'api/v2/point/day-receipt/pdf/'
export const RETROSPECTIVE_INFO = urlApi + 'api/v1/retrospective/User'

//VALIDATE ACCESS TO V2
export const ACCESS_TO_V2 = urlApi + 'api/v1/company/applicationInfo/web'
export const SET_TOKEN = urlApi + 'api/v1/access/token'

//LOGOUT
export const GET_LOGOUT = urlApi + 'api/v1/user/logout'

//CROSS
export const SECURITY_CROSS = urlApiV2 + 'security/cross/'

//TERMS OF USE
export const CHECK_TERMS_OF_USE = urlApiV2 + 'v1/TermsOfUse/Accept';
export const TERMS_OF_USE = urlApiV2 + 'v1/TermsOfUse/Locale';

// PRIVACY POLICIES
export const PRIVACY_POLICIES = urlApiV2 + 'v1/PrivacyPolicies/Locale'

//PDI
export const PDI = urlApiV2+ 'v1/pdi/web/dashboard'



// WEBPACK FOOTER //
// ./src/urlConfig.js